<div id="note-list"
*ngFor="let pNote of getPrivateNotes()" class="comment-item p-3 mb-2 rounded border border-light shadow-sm">

  <!-- Comment header -->
  <div class="d-flex justify-content-between align-items-start mb-2">
    <div class="text-muted small">
      {{pNote.userFirstName}} le {{pNote.dateCreate | date:'d MMMM yyyy'}} à {{pNote.dateCreate | date:"HH'h'mm"}}
    </div>
    <div class="text-end">
      <i *ngIf="currentUser?.ident === pNote.utilIdent"
        (click)="editPrivateNote(pNote)"
        class="fa-regular fa-pencil ms-2 text-primary"
        style="cursor:pointer;"></i>
      <i *ngIf="currentUser?.ident === pNote.utilIdent"
        (click)="rmPrivateNote(pNote)"
        class="fa-regular fa-trash-can ms-2 text-danger"
        style="cursor:pointer;"></i>
    </div>
  </div>

  <!-- Comment content -->
  <div class="comment-content">
    {{pNote.content}}
  </div>

</div>
